import WithClickLoadingWrapper from './WithClickLoadingWrapper'

export default WithClickLoadingWrapper
